module.exports = __webpack_public_path__ + "img/Layer_13.fc3d355c.png";